const Legend = ({ areBusStopsVisible }: { areBusStopsVisible: boolean }) => (
  <div
    className="absolute bottom-auto left-5 top-32 z-10 rounded bg-[#171717]/80 p-4 sm:bottom-4 sm:top-auto md:bottom-10"
    style={{ minWidth: "173px" }}
  >
    {/* Bus Stops */}
    {areBusStopsVisible && (
      <div className="mb-2">
        <div className="mb-2 text-sm uppercase text-white">Bus Stop Shade</div>
        <div className="mb-1 flex items-center">
          <div
            style={{
              width: "10px",
              height: "10px",
              backgroundColor: "#4D4D4D",
              borderRadius: "50%",
              border: "1px solid #000000",
              marginLeft: "10px",
              marginRight: "15px",
            }}
          />
          <span className="text-xs text-white">5%</span>
        </div>
        <div className="flex items-center">
          <div
            style={{
              width: "30px",
              height: "30px",
              backgroundColor: "#4D4D4D",
              borderRadius: "50%",
              border: "1px solid #000000",
              marginRight: "4px",
            }}
          />
          <span className="text-xs text-white">100%</span>
        </div>
      </div>
    )}

    {/* Bus Routes */}
    <div className="flex items-center">
      <div
        style={{
          width: "20px",
          height: "2px",
          backgroundColor: "#F9F3E7",
          transform: "rotate(-45deg)",
          marginRight: "8px",
        }}
      />
      <div className="text-sm uppercase text-white">Bus Routes</div>
    </div>

    {/* Shade */}
    <div className="mt-2">
      <div className="mb-2 ml-[28px] flex items-center text-sm uppercase text-white">Shade</div>
      <div className="flex items-center">
        <span className="mr-2 text-xs text-white">0</span>
        <div
          className="h-4 flex-grow"
          style={{
            background: "linear-gradient(to left, #47505F, #8B929E, #C2CAD4, #F6D0B1)",
          }}
        />
        <span className="ml-2 text-xs text-white">&#8250;50%</span>
      </div>
    </div>
  </div>
)

export default Legend
